// 基于 localStorage.StrIdentity 的身份校验助手
// 身份层级（rank 从低到高）：manager < orgManager < areaManager < systemAdmin < superAdmin
// “X 或更高”= rank >= X，可创建某身份 = 当前 rank 严格大于该身份 rank
const RANK = {
    manager: 1,
    orgManager: 2,
    areaManager: 3,
    systemAdmin: 4,
    superAdmin: 5,
}

// 读取当前登录者身份；缺失时按普通管理员兜底
export function getIdentity() {
    return localStorage.getItem('StrIdentity') || 'manager'
}

function rankOf(identity) {
    return RANK[identity] ?? 0
}

// 超级管理员（仅一个 admin 账号）
export function isSuperAdmin() {
    return getIdentity() === 'superAdmin'
}

// 系统管理员及以上（superAdmin | systemAdmin）：可创建区域管理员
export function isSystemOrAbove() {
    return rankOf(getIdentity()) >= RANK.systemAdmin
}

// 区域管理员及以上（superAdmin | systemAdmin | areaManager）：
// 可见组织级视图（报表“组织”筛选、SyHome 落地页、School 添加按钮等）、可创建组织管理员
export function isAreaOrAbove() {
    return rankOf(getIdentity()) >= RANK.areaManager
}

// 当前用户能否创建区域管理员
export function canCreateAreaManager() {
    return isSystemOrAbove()
}

// 当前用户能否创建组织管理员
export function canCreateOrgManager() {
    return isAreaOrAbove()
}

// 当前用户可分配的身份列表（rank 严格小于当前用户），供 User.vue 表单下拉使用
export function assignableIdentities() {
    const cur = rankOf(getIdentity())
    return Object.keys(RANK).filter(k => RANK[k] < cur)
}

const IDENTITY_LABELS = {
    manager: '普通管理员',
    orgManager: '组织管理员',
    areaManager: '区域管理员',
    systemAdmin: '系统管理员',
    superAdmin: '超级管理员',
}

export function identityLabel(identity) {
    return IDENTITY_LABELS[identity] || identity
}

// 可分配身份的 {value,label} 选项列表，供下拉选择器使用
export function assignableIdentityOptions() {
    return assignableIdentities().map(id => ({value: id, label: IDENTITY_LABELS[id] || id}))
}
